import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-performance-activity-metrics-attempt-benchmarks',
  templateUrl: './agent-performance-activity-metrics-attempt-benchmarks.component.html',
  styleUrls: ['./agent-performance-activity-metrics-attempt-benchmarks.component.scss']
})
export class AgentPerformanceActivityMetricsAttemptBenchmarksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
